<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("userLoginLog") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<template #header>
			<h1 class="page-title p-0">{{ $t("loginLog.title") }}</h1>
		</template>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							{{ $t("loginLog.title") }}
						</li>
					</ol>
				</div>
			</div>
		</template>
		<section class="content">
			<div class="container">
				<div class="row">
					<div class="col-3">&nbsp;</div>
					<div class="col-6">
						<div class="intro">
							{{ $t("loginLog.intro1") }}
							<br />
							{{ $t("loginLog.intro2") }}
						</div>

						<table class="table table-striped table-sm col-8">
							<thead>
								<th scope="col">{{ $t("loginLog.date") }}</th>
								<th scope="col">{{ $t("loginLog.IP") }}</th>
							</thead>
							<tbody>
								<template v-if="loginLogs.length != 0">
									<tr
										v-for="log in loginLogs"
										:key="log.login_log_id">
										<td>
											{{ log.login_time }}
										</td>
										<td>
											{{ log.login_IP }}
										</td>
									</tr>
								</template>
								<template v-else>
									<tr>
										<td colspan="2" class="text-center">
											{{ $t("loginLog.empty") }}
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";
export default {
	name: "userLoginLog",
	props: {},
	data() {
		return {
			loginLogs: [],
		};
	},
	methods: {
		getLoginLogs: function () {
			axios.get("/logs/getLogin").then(
				function (response) {
					this.loginLogs = response.data;
				}.bind(this)
			);
		},
	},
	created() {
		this.getLoginLogs();
	},
	mounted() {},
	components: {
		FrontendLayout,
	},
};
</script>

<style scoped>
.intro {
	text-align: center;
	font-weight: bold;
	margin: 1.1rem;
}
</style>
